<mat-tab-group>
  <mat-tab label="Employment Details">
    <div class="tab-content-pad">
      <div class="detail-card">

        <!-- Card Header: avatar + name + edit button -->
        <div class="detail-card-header">
          <div class="employee-identity">
            <div class="employee-avatar">
              <img [src]="imgUrl" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:8px;"
                (error)="imgError = true" *ngIf="!imgError">
              <i class="fas fa-user-circle" *ngIf="imgError" style="font-size: 2.4rem; color: #2e7d32;"></i>
            </div>
            <div>
              <p class="employee-name">{{ name }}</p>
              <span class="employee-role-badge">{{ this.output[0]?.role || 'Employee' }}</span>
            </div>
          </div>
          <a class="btn-edit" (click)="EditEmployee(); getValue();">
            <i class="fas fa-pencil-alt"></i> Edit
          </a>
        </div>

        <!-- Two-column fields grid -->
        <div class="detail-fields-grid">

          <div class="detail-field-item">
            <span class="field-label">Department</span>
            <span class="field-value" [class.empty]="!this.output[0]?.department">
              {{ this.output[0]?.department || '—' }}
            </span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">Role</span>
            <span class="field-value" [class.empty]="!this.output[0]?.role">
              {{ this.output[0]?.role || '—' }}
            </span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">Company Brand</span>
            <span class="field-value" [class.empty]="!this.output[0]?.company_brand">
              {{ this.output[0]?.company_brand || '—' }}
            </span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">Product Brand</span>
            <span class="field-value" [class.empty]="!this.output[0]?.product_brand">
              {{ this.output[0]?.product_brand || '—' }}
            </span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">Folder</span>
            <span class="field-value" [class.empty]="!this.output[0]?.folder">
              {{ this.output[0]?.folder || '—' }}
            </span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">Mobile</span>
            <span class="field-value" [class.empty]="!this.output[0]?.mobile">
              {{ this.output[0]?.mobile || '—' }}
            </span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">Monthly Sales Target</span>
            <span class="field-value">{{ this.output[0]?.monthly_invoice_target ?? 0 }}</span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">Monthly Receipt Target</span>
            <span class="field-value">{{ this.output[0]?.monthly_receipts_target ?? 0 }}</span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">Yearly Sales Target</span>
            <span class="field-value">{{ this.output[0]?.current_year_sales_target ?? 0 }}</span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">Yearly Receipt Target</span>
            <span class="field-value">{{ this.output[0]?.current_year_receipt_target ?? 0 }}</span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">Today Visit Target</span>
            <span class="field-value">{{ this.output[0]?.today_visit_target ?? 0 }}</span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">Current Month Visit Target</span>
            <span class="field-value">{{ this.output[0]?.current_month_visits_target ?? 0 }}</span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">KPI</span>
            <span class="field-value">{{ this.output[0]?.default_kpi_value ?? '—' }}</span>
          </div>

        </div>
      </div>
    </div>
  </mat-tab>

  <mat-tab label="Monthly Sales Target">
    <div class="container">
      <div class="row">
        <div class="col-12 d-flex justify-content-end ">
          <div class="py-4 w-25">

            <ng-select [items]="yearList" bindLabel="year" bindValue="year" [(ngModel)]="currentYear"
              (ngModelChange)="getEmployeeTarget(employeeId);" name="year" id="year" class="year"
              placeholder="Select a Year"></ng-select>

          </div>
        </div>
      </div>
    </div>
    <div class="sale-table">
      <div class="table-responsive">
        <table class="table align-middle text-center custom-table">
          <thead>
            <tr>
              <th scope="col">Year & Month</th>
              <th scope="col">Monthly Target</th>
              <th scope="col">Actual Sale</th>
              <th scope="col">Next Month Target</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let target of employeeTarget?.monthly_targets">
              <td>{{ getMonthName(target.year_month) }}</td>
              <td>{{ target.monthly_target }}</td>
              <td>{{ target.actual_sales }}</td>
              <td>{{ target.next_month_target }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </mat-tab>"
  <mat-tab label="KPIS">
    <div class="card card-primary card-outline style">
      <div class="card-body box-profile">

        <a class="btn btn-info btn-sm edit" style="margin-left: 70%;" (click)='EditEmployee();getValue();'>
          <i class="fas fa-pencil-alt"></i>
          Edit
        </a>

        <div class="card-body">
          <h5 class="kpi-section-title">Monthly KPI</h5>

          <div class="table-responsive">
            <table class="table align-middle text-center kpi-table">
              <thead>
                <tr>
                  <th>Month</th>
                  <th>Agreed Sales</th>
                  <th>Agreed Receipts</th>
                  <th>Active Qualified</th>
                  <th>Active Lead</th>
                  <th>Non Qualified → Qualified</th>
                  <th>Overdue Inactive</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let c of output[0].monthly_employee_kpi_models; index as i">

                  <td><strong>{{ c.month_year }}</strong></td>
                  <td>{{ c.agreed_sales_kpi ?? '-' }}</td>
                  <td>{{ c.agreed_receipts_kpi ?? '-' }}</td>

                  <td>
                    <div class="dual-cell">
                      <div class="dual-item">
                        <span class="dual-label">Count</span>
                        <span class="dual-colon">:</span>
                        <span class="badge-count">{{ c.active_qualified_count ?? '-' }}</span>
                      </div>
                      <div class="dual-item">
                        <span class="dual-label">KPI</span>
                        <span class="dual-colon">:</span>
                        <span class="badge-kpi">{{ c.active_qualified_kpi ?? '-' }}</span>
                      </div>
                    </div>
                  </td>

                  <td>
                    <div class="dual-cell">
                      <div class="dual-item">
                        <span class="dual-label">Count</span>
                        <span class="dual-colon">:</span>
                        <span class="badge-count">{{ c.active_leads_count ?? '-' }}</span>
                      </div>
                      <div class="dual-item">
                        <span class="dual-label">KPI</span>
                        <span class="dual-colon">:</span>
                        <span class="badge-kpi">{{ c.active_leads_kpi ?? '-' }}</span>
                      </div>
                    </div>
                  </td>

                  <td>
                    <div class="dual-cell">
                      <div class="dual-item">
                        <span class="dual-label">Count</span>
                        <span class="dual-colon">:</span>
                        <span class="badge-count">{{ c.non_qualified_to_qualified_count ?? '-' }}</span>
                      </div>
                      <div class="dual-item">
                        <span class="dual-label">KPI</span>
                        <span class="dual-colon">:</span>
                        <span class="badge-kpi">{{ c.non_qualified_to_qualified_kpi ?? '-' }}</span>
                      </div>
                    </div>
                  </td>

                  <td>
                    <div class="dual-cell">
                      <div class="dual-item">
                        <span class="dual-label">%</span>
                        <span class="dual-colon">:</span>
                        <span class="badge-count">{{ c.overdue_inactive_percentage ?? '-' }}%</span>
                      </div>
                      <div class="dual-item">
                        <span class="dual-label">KPI</span>
                        <span class="dual-colon">:</span>
                        <span class="badge-kpi">{{ c.overdue_inactive_kpi ?? '-' }}</span>
                      </div>
                    </div>
                  </td>

                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Leave Management">

    <div class="card card-primary card-outline style">
      <div class="card-body box-profile">

        <p>
          <b>Leave Management</b>
        </p>
        <!------------Add edit button----------------->
        <a class="btn btn-info btn-sm edit" style="margin-left: 70%;" (click)='EditEmployee();getValue();'>
          <i class="fas fa-pencil-alt">
          </i>
          Edit
        </a>

        <div class="card-body">

          <div class="row">
            <div class="col-md-6">

              <div class="form-group">
                <label>Year</label>
                <select #teams class="form-control select2 select2-hidden-accessible" style="width: 100%;"
                  data-select2-id="1" tabindex="-1" aria-hidden="true" #mySelectYear
                  (change)='YearSelected(mySelectYear.value)'>
                  <option>2023</option>
                  <option>2024</option>
                  <option>2025</option>
                  <option>2026</option>
                </select>
              </div>

              <div class="form-group">
                <label>Vocation</label>
                <div class="space" *ngFor="let d of vocation;index as i">
                  <span>{{DateFormat(d)}}</span>
                </div>
              </div>



            </div>


            <div class="col-md-6">
              <div class="form-group">
                <label>Month</label>
                <select #teams class="form-control select2 select2-hidden-accessible" style="width: 100%;"
                  data-select2-id="1" tabindex="-1" aria-hidden="true" #mySelectMonth
                  (change)='MonthSelected(mySelectMonth.value)'>
                  <option selected="selected" data-select2-id="1" hidden>Select</option>
                  <option *ngFor="let d of Month;index as i" data-select2-id="2" [value]="i">{{d.name}}</option>

                </select>
              </div>

              <div class="form-group">
                <label>Sick leave</label>
                <div class="space" *ngFor="let d of sick_leaves;index as i">
                  <span>{{DateFormat(d)}}</span>
                </div>
              </div>

            </div>

          </div>


        </div>


      </div>
    </div>

  </mat-tab>
  <mat-tab label="Attendance Management">

    <div class="card-body">
      <div class="d-flex justify-content-end ">

        <button routerLink="/admin/edit-employee" class="btn btn-info btn_allign">edit</button>
      </div>
      <form class="form-data" [formGroup]="creationForm">

        <section class="main-page-box">
          <div class="row">
            <div class="col-12 col-sm-8 col-md-6">
              <div class="row">
                <div class="col-12">
                  <label for="workin_time" class="required">Work in time</label>
                  <input class="form-control" name="workin_time" type="time" id="workin_time"
                    formControlName="workin_time">
                  <div *ngIf="creationForm.get('workin_time')?.invalid && creationForm.get('workin_time')?.touched"
                    class="text-danger">
                    Work In Time is required
                  </div>
                </div>
                <div class="col-12">
                  <label for="is_department_specific" class="required boxcheck">Is department Specific</label>
                  <input class="form" type="checkbox" value="" id="is_department_specific" name="is_department_specific"
                    formControlName="is_department_specific" class="mt-1">
                  <div
                    *ngIf="creationForm.get('is_department_specific')?.invalid && creationForm.get('is_department_specific')?.touched"
                    class="text-danger">
                    Department Specific is Required
                  </div>
                </div>
                <div class="col-12">
                  <label for="is_location_restricted" class="required">Weekly Working Day</label>
                  <div *ngFor="let day of weeKDays; let i = index">
                    <mat-checkbox [checked]="day.checked">
                      {{ day.week }}
                    </mat-checkbox>
                  </div>
                </div>
              </div>


            </div>
            <div class="col-12 col-sm-8 col-md-6">
              <div class="row">

                <div class="col-12">
                  <label for="workout_time" class="required">Work out time</label>
                  <input class="form-control" type="time" name="workout_time" id="workout_time"
                    formControlName="workout_time">
                  <div *ngIf="creationForm.get('workout_time')?.invalid && creationForm.get('workout_time')?.touched"
                    class="text-danger">
                    Work out time is Required
                  </div>
                </div>
                <div class="col-12">
                  <label for="is_location_restricted" class="required boxcheck">Is location restricted</label>
                  <input class="form" type="checkbox" value="" id="is_location_restricted" name="is_location_restricted"
                    formControlName="is_location_restricted">
                  <div
                    *ngIf="creationForm.get('is_location_restricted')?.invalid && creationForm.get('is_location_restricted')?.touched"
                    class="text-danger">
                    Location Specific Required
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      </form>
    </div>

  </mat-tab>

</mat-tab-group>